export const modelsDir = '/biseibutsugari/models/';